import React from 'react'
import { CCard, CCardBody, CBadge } from '@coreui/react-pro'

const CommunityRoundWinnerModal = ({ item }) => {
  const { payload } = item

  if (!payload) return <p>No data available</p>

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '10px' }}>🥇</h1>
        <h5>Round Winner</h5>
        <CBadge color="info">ROUND WINNER</CBadge>
      </div>

      <CCard>
        <CCardBody>
          <div style={{ marginBottom: '12px' }}>
            <strong>Winner:</strong> {payload.full_name || 'N/A'}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Team:</strong> {payload.team_name || 'N/A'}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Round:</strong>{' '}
            <CBadge color="secondary"> #{payload.round_number || 'N/A'}</CBadge>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Round Points:</strong>{' '}
            <CBadge color="success">{payload.round_points || 0}</CBadge>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Overall Points:</strong>{' '}
            <CBadge color="success">{payload.overall_points || 0}</CBadge>
          </div>
          {payload.description && (
            <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #ddd' }}>
              <strong>Description:</strong>
              <p style={{ marginTop: '8px', marginBottom: 0 }}>{payload.description}</p>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  )
}

export default CommunityRoundWinnerModal
